/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { MBox } from '../atoms/MBox';
import { getDefaultMobileWidth } from '../custom-hooks/screen-detector';

export const StyledDiscountCodeCon = styled(MBox)`
  .mr-discount-code-form {
    width: 100%;
    display: flex;
  }
`;

export const DiscountCodeCon = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${props => (props.padding ? props.padding : '1em 0')};
  border-top: ${props => (props.isBordered ? '1px solid #00000033' : null)};
  border-bottom: ${props => (props.isBordered ? '1px solid #00000033' : null)};
  background-color: ${props => props.theme.discoundCodeWidgetBackgroundColor};
  font-size: 10px;

  @media (max-width: 360px) {
    margin-left: 0 !important;
  }

  button {
    margin: 0;
  }

  .discount-code-textfield {
    margin-right: 1em;
    input {
      box-sizing: border-box;
      width: 100%;
      outline: none;
      border: 1px solid transparent;
      border-radius: 3px;
      box-shadow: none;
      padding: 10px 12px;
      margin: 0px !important;
      border-color: ${props =>
        props.isCodeEntered
          ? props.theme.discountCodeButtonColor
          : props.isInvalidCode
            ? props.theme.discountCodeInvalidTextColor
            : props.theme.discoundCodeInputBorderColor};
      font-size: ${props => props.theme.discountCodeButtonFontSize}px;
      background-color: ${props =>
        props.theme.discoundCodeInputBackgroundColor};
      @media (max-width: ${getDefaultMobileWidth()}px) {
        font-size: ${props => props.theme.discountCodeButtonMobileFontSize}px;
      }
      height: 100%;

      &:disabled {
        border-color: ${props => props.theme.discountCodeDefaultButtonColor};
        cursor: not-allowed;
      }

      &:focus-visible {
        border: 1px solid ${props => props.theme.discountCodeButtonColor};
        outline: none;
        outline-offset: 0px;
        box-shadow: none;
      }
    }
  }

  .error-text {
    color: ${props => props.theme.discountCodeInvalidTextColor};
    font-weight: ${props => props.theme.discountCodeInvalidFontWeight};
    font-style: ${props => props.theme.discountCodeInvalidFontStyle};
    text-decoration: ${props => props.theme.discountCodeInvalidTextDecoration};
    font-size: ${props => props.theme.discountCodeInvalidFontSize}px;
    @media (max-width: ${getDefaultMobileWidth()}px) {
      font-size: ${props => props.theme.discountCodeInvalidMobileFontSize}px;
    }
    margin-bottom: 0px;
    margin-top: 0.3rem;
  }

  .mr-discount-code-chip {
    background-color: lightgray;
    border-radius: 3px;
    .mr-discount-code-text {
      line-height: 1;
      font-size: 14px;
      color: black;
    }
  }
`;
/* eslint-enable no-nested-ternary */
